import { configureStore } from '@reduxjs/toolkit';

import { alertReducer } from './alert.slice';
import { authReducer } from './auth.slice';
import { usersReducer } from './users.slice';
import { shoppingListsReducer } from './shoppingLists.slice';
import { mealPlansReducer } from './mealPlans.slice';

export * from './alert.slice';
export * from './auth.slice';
export * from './users.slice';
export * from './mealPlans.slice';
export * from './shoppingLists.slice';

export const store = configureStore({
    reducer: {
        alert: alertReducer,
        auth: authReducer,
        users: usersReducer,
        mealPlans: mealPlansReducer,
        shoppingLists: shoppingListsReducer
    },
});